$(() => {
    if (document.getElementById('freee-approval-flow-routes') != null) {
        $('.js-approval_flow_route').on('click', function(e) {
            $('input[name="approval_flow_route_id"]').val($(this).data('id'));
            $('#approval_flow_route_form').submit();
        });
    }
});
